import Api from '@/services/Api'
import store from '@/store'

export default {
  signin(data) {
    return Api.httpServer().post('api/authen.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  authen(data) {
    return this.httpServer().post('api/authen.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  prListCount(data) {
    return Api.httpServer().post(
        'pr/default.asp?controller=prdochd&action=listcount', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  SendMail(data) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=Emp&action=SendMail',
      data
    )
  },
  linestatus(data) {
    return Api.httpServer().post('line/linestatus.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  linenotify(data) {
    return Api.httpServer().post('line/lineNotify.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailnotify(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer().post('line/emailNotify.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailotp(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer().post('line/emailOTP.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  lineotp(data) {
    return Api.httpServer().post('line/lineOTP.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  lineotpcheck(data) {
    return Api.httpServer().post('line/lineOTPCheck.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  budgetProject(data) {
    return Api.httpServer().post(
        'model_tb/default.asp?controller=Emp&action=Other&other=budgetProject', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  budget(data) {
    return Api.httpServer().post(
        'model_tb/default.asp?controller=Emp&action=Other&other=budget', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  getEmp(data) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=emp&action=getEmp',
      data
    )
  },
  prConfig(data) {
    return Api.httpServer().post(
      'pr/default.asp?controller=prconfig&action=listbyparam',
      data
    )
  },
  empConfig(data) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emp&action=empconfig',
      data
    )
  },  
  empUpdate(data) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emp&action=Update',
      data
    )
  },    
}